import { render, staticRenderFns } from "./CustomerLogo.vue?vue&type=template&id=5cea790d"
import script from "./CustomerLogo.vue?vue&type=script&lang=js"
export * from "./CustomerLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports